import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectAuthStatus } from "reducers/auth";

const Private: React.FC = ({ children }) => {
  const authStatus = useSelector(selectAuthStatus);

  if (authStatus === "signed_out") return <Navigate to="/sign-in" />;

  return <React.Fragment>{children}</React.Fragment>;
};

export default Private;
